import { StandardValueObject, SubComponentProps, ViewModeDictionary } from '../EventFormField.types';
import { QDatepicker } from '@qualio/ui-components';
import {
  convertISOCalendarDateToDisplayDate,
  formatDatePickerComponentDateToString,
} from '../../../utils/datetimeUtils';
import { createFieldValueArray } from '../../../utils/eventFormUtils';
import ReadonlyWrapper from './ReadOnlyWrapper';
import TextOr from '../../TextOr/TextOr';
import './DateField.css';
const DateField = (props: SubComponentProps) => {
  const { fieldValues, onChange, fieldId, mode } = props;

  // TODO:  QEV-2813
  const valueObj = fieldValues[0] as StandardValueObject | undefined;
  const convertToDisplayDate = (value: string): string => {
    return convertISOCalendarDateToDisplayDate(value);
  };

  if (mode === ViewModeDictionary.READONLY) {
    return (
      <ReadonlyWrapper>
        <TextOr value={valueObj?.value} transform={convertToDisplayDate} fontSize="sm" />
      </ReadonlyWrapper>
    );
  }

  return (
    <div className="quality-events-container-datepicker-wrapper">
      <QDatepicker
        isClearable={true}
        value={valueObj?.value}
        data-cy={'date-picker'}
        onChange={(date) => {
          const value = date ? formatDatePickerComponentDateToString(date) : date;
          onChange(createFieldValueArray(value, fieldId, valueObj));
        }}
      />
    </div>
  );
};

export default DateField;
